
sizeInterval = setInterval(function(){
    var sizeOptions = document.querySelectorAll('.list-maat li input[type=checkbox]:not(.autoStock), .list-boordmaat li input[type=checkbox]:not(.autoStock), .list-confectiemaat li input[type=checkbox]:not(.autoStock), .list-schoenmaat li input[type=checkbox]:not(.autoStock)');
    for(size in sizeOptions) {
        sizeOptions[size].className += 'autoStock';
        sizeOptions[size].onclick = function() {
            document.querySelector('.thb-filter-availability input[type=checkbox]').checked = true;
        };
    }
}, 500);
